import { render, staticRenderFns } from "./EditRowTr.vue?vue&type=template&id=5807237f&scoped=true"
import script from "./EditRowTr.vue?vue&type=script&lang=js"
export * from "./EditRowTr.vue?vue&type=script&lang=js"
import style0 from "./EditRowTr.vue?vue&type=style&index=0&id=5807237f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807237f",
  null
  
)

export default component.exports